import { dealerCalendar } from '../../../../mocks/calendar.mock';

import FlowState from '../../../../models/store/modules/otbc/flow-state.model';

import DateService from '../../../../services/date.service';

export const getters = {
  dealerCalendar: (state: FlowState) => {
    const calendar = DateService.getDatesAvailability(state.dealerCalendar);
    return calendar.availableDates && calendar.closedDates
      ? calendar
      : dealerCalendar;
  },
  formattedSelectedDay: (state: FlowState) =>
    state.selectedDay?.toISOString().split('T')[0],
  isTestDriveFromHomeEnabled: (state: FlowState): boolean =>
    state.isTestDriveFromHome ?? false,
  testDriveFromHomeWhitelistedDealers: (state: FlowState): string[] =>
    state.testDriveFromHomeWhitelistedDealers ?? [],
  didUserConsentWithOneDoc: (state: FlowState): boolean =>
    state.didUserConsentWithOneDoc ?? false,
};
